import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    breadCrumb: {
      margin: theme.spacing(2)
    },
    section: {
      margin: theme.spacing(2)
    },
    itemsSection: {
      marginTop: theme.spacing(3),

      [theme.breakpoints.down("sm")]: {
        border: 0
      }
    },
    otherSection: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(10),

      [theme.breakpoints.down("sm")]: {
        border: 0
      }
    },
    list: {
      marginBottom: theme.spacing(10)
    },
    listItemTight: {
      padding: 0
    },
    sectionContent: {
      paddingTop: 0
    },
    loading: {
      marginTop: theme.spacing(10)
    },
    storeSelect: {
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(2)
    },
    fabButtons: {
      margin: theme.spacing(2),
      position: "fixed",
      bottom: 0,
      right: 0
    },
    backButton: {
      marginRight: theme.spacing(2)
    },
    nextButton: {
      color: "#fff",
      backgroundColor: "#58853e"
    },
    cancelButton: {
      color: "#fff",
      backgroundColor: "#c0392b",

      marginLeft: theme.spacing(2)
    },
    field: {
      display: "flex",
      justifyContent: "center"
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  })
);
